export default __webpack_public_path__ + "static/AppBeers6-0d09269c997591f67b17c9c69c92a653.png";